module.exports = __webpack_public_path__ + "static/media/govbr_logo_white.57ed50a5.svg";